'use client';

import { useState } from 'react';
import HeroSection from './HeroSection';
import HowItWorksSection from './HowItWorksSection';
import SecuritySection from './SecuritySection';
import UseCasesSection from './UseCasesSection';
import TestimonialsSection from './TestimonialsSection';
import FooterSection from './FooterSection';

export default function HomepageInteractive() {
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);

  const handleFreeTrial = () => {
    setShowFreeTrialModal(true);
    // In production: navigate to signup page or show modal
    console.log('Free trial clicked');
  };

  const handleBookDemo = () => {
    setShowDemoModal(true);
    // In production: navigate to demo booking page or show modal
    console.log('Book demo clicked');
  };

  return (
    <>
      <HeroSection onFreeTrial={handleFreeTrial} onBookDemo={handleBookDemo} />
      <HowItWorksSection />
      <SecuritySection />
      <UseCasesSection />
      <TestimonialsSection />
      <FooterSection />
      {/* Modals would go here in production */}
      {showFreeTrialModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowFreeTrialModal(false)}>
          <div className="bg-white p-8 rounded-2xl max-w-md" onClick={(e) => e?.stopPropagation()}>
            <h3 className="text-2xl font-serif mb-4">Kostenlos testen</h3>
            <p className="text-muted-foreground mb-4">Registrierung würde hier starten...</p>
            <button onClick={() => setShowFreeTrialModal(false)} className="bg-primary text-primary-foreground px-6 py-2 rounded-full">
              Schließen
            </button>
          </div>
        </div>
      )}
      {showDemoModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowDemoModal(false)}>
          <div className="bg-white p-8 rounded-2xl max-w-md" onClick={(e) => e?.stopPropagation()}>
            <h3 className="text-2xl font-serif mb-4">Demo buchen</h3>
            <p className="text-muted-foreground mb-4">Demo-Buchung würde hier starten...</p>
            <button onClick={() => setShowDemoModal(false)} className="bg-primary text-primary-foreground px-6 py-2 rounded-full">
              Schließen
            </button>
          </div>
        </div>
      )}
    </>
  );
}